import { FC } from 'react'
import StepHeader, {
    IStepHeaderStep,
} from '@/src/common/components/elements/Layout/StepHeader'
import DefaultPartnerStepHeader from '@/src/modules/partners/DefaultPartnerStepHeader'
import { TPartnerPayload } from '@/src/modules/partners/types'
import isEmpty from 'lodash/isEmpty'

const CheckoutHeader: FC<{
    currentStep: number
    hasPlastic: boolean
    partnerData?: TPartnerPayload
}> = ({ currentStep, hasPlastic, partnerData }) => {
    if (partnerData) {
        const showMobileNav =
            isEmpty(partnerData) ||
            (partnerData?.programConfig?.show_mobile_nav ?? true)

        return (
            <DefaultPartnerStepHeader
                partnerData={partnerData}
                currentStep={currentStep}
                showCart={false}
                showMobileNav={showMobileNav}
            />
        )
    }

    let stepNames: IStepHeaderStep[] = [
        { text: 'Payment' },
        { text: 'Complete' },
    ]

    if (hasPlastic) {
        stepNames = [{ text: 'Shipping' }, ...stepNames]
    }

    return (
        <StepHeader
            message={''}
            steps={stepNames}
            currentStep={currentStep}
            partnerData={partnerData}
        />
    )
}

export default CheckoutHeader
